export var FilesSortValuesEnum;
(function (FilesSortValuesEnum) {
    FilesSortValuesEnum["newest"] = "newest";
    FilesSortValuesEnum["group"] = "group";
})(FilesSortValuesEnum || (FilesSortValuesEnum = {}));
